<div
  cdkDropList
  [cdkDropListData]="horizontalPositionOfGroupCreelPosition.group"
  [cdkDropListConnectedTo]="connectedDroplist"
  (cdkDropListDropped)="drop($event)"
  [id]="horizontalPositionOfGroupCreelPosition.id"
  class="color-group"
  [class.can-show-warning]="canShowWarning()"
>
  <div class="header" [class.can-show-warning]="canShowWarning()" fxLayoutAlign="start center" (click)="onMaterialTypeGroupClick(horizontalPositionOfGroupCreelPosition.isSelected, $event)">
    <div class="warning-indicator" *ngIf="canShowWarning()"></div>
    <div class="selected-indicator" *ngIf="canShowSelectedIndicator()"></div>

    <div fxFlex>
      <mat-icon *ngIf="canEditMaterialSet" class="drag-handle" svgIcon="drag-handle"></mat-icon>
      <span fxFlex>{{ 'GENERAL.GROUP' | bmsTranslate: {count: 1} }}</span>
    </div>

    <mat-icon class="warning-icon" *ngIf="canShowWarning()" svgIcon="error"></mat-icon>

    <div fxLayoutAlign="end center" fxLayoutGap="8px" class="amount-actions">
      <button mat-icon-button (click)="decrementAmount($event)" [disabled]="!canDecrementAmount()" class="mat-icon-action-button-sm">
        <mat-icon svgIcon="subtract-small"></mat-icon>
      </button>

      <span>{{ horizontalPositionOfGroupCreelPosition.amount }}</span>

      <button mat-icon-button (click)="incrementAmount($event)" [disabled]="!canEditMaterialSet" class="mat-icon-action-button-sm">
        <mat-icon svgIcon="add-small"></mat-icon>
      </button>
    </div>
  </div>

  <div class="content">
    <div *ngFor="let horizontalPositionOfGroupCreelPosition of horizontalPositionOfGroupCreelPosition.group">
      <div cdkDrag (cdkDragEntered)="onDragEntered($event)" (cdkDragStarted)="onDragStarted($event)" class="cdk-draggable-item">
        <div *cdkDragPlaceholder class="drag-indicator"></div>
        <app-material-type
          *ngIf="creelPositionDetailsComponent.canShowMaterialType(horizontalPositionOfGroupCreelPosition)"
          [horizontalPositionOfMaterialTypeCreelPosition]="horizontalPositionOfGroupCreelPosition"
          [indexOfHorizontalPositionOfCreelPosition]="getPositionOfMaterialTypeCreel(horizontalPositionOfGroupCreelPosition)"
          [canEditMaterialSet]="canEditMaterialSet"
          (typeChanges)="emitGroupChanges()"
        ></app-material-type>

        <app-material-type-group
          [connectedDroplist]="connectedDroplist"
          *ngIf="horizontalPositionOfGroupCreelPosition.isGroup()"
          [horizontalPositionOfGroupCreelPosition]="horizontalPositionOfGroupCreelPosition"
          [horizontalPositionsOfCreelPosition]="horizontalPositionsOfCreelPosition"
          [canShowError]="canShowError"
          [canEditMaterialSet]="canEditMaterialSet"
          [isDraggingOver]="isDraggingOver"
          (groupChanges)="emitGroupChanges()"
        ></app-material-type-group>
      </div>
    </div>
  </div>
</div>
